import React from 'react';

import CallToAction from '../CallToAction';
import Image from '../Image/GatsbyImage';

import CogWhite from './assets/cog-white.svg';

import { Container, Heading, Subhead, Wrapper } from './styles/index.styled';

const InlineBanner = ({ heading, subhead, button }) => (
  <Container>
    <Wrapper>
      <Image src={CogWhite} alt="Cog" width="35px" height="35px" />
      {heading && <Heading>{heading}</Heading>}
      {subhead && <Subhead dangerouslySetInnerHTML={{ __html: subhead }} />}
    </Wrapper>
    {button && <CallToAction {...button} variant="Filled - White" size="md" />}
  </Container>
);

export default InlineBanner;
